"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_options_controls_1 = require("owa-options-controls");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var updateTxpFlag_1 = require("../actions/updateTxpFlag");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var TxpEventsPanel_1 = require("./TxpEventsPanel");
var ENABLE = 'enable';
var DISABLE = 'disable';
var TxpFull = /** @class */ (function (_super) {
    tslib_1.__extends(TxpFull, _super);
    function TxpFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The event handler for the radio button to enable or disable txp
         */
        _this.eventsToEmailUpdated = function (ev, option) {
            updateTxpFlag_1.default('EventsFromEmailEnabled', option.key == ENABLE);
        };
        /**
         * The event handler behind the OptionsCheckbox for setting the CreateEventsFromEmailAsPrivate flag
         */
        _this.updateCreateEventsFromEmailAsPrivateFlag = function (ev, checked) {
            updateTxpFlag_1.default('CreateEventsFromEmailAsPrivate', checked);
        };
        return _this;
    }
    TxpFull.prototype.render = function () {
        var optionStore = this.props.optionStore;
        var mailboxCalendarConfiguration = owa_calendar_configuration_1.getCalendarConfiguration();
        if (!mailboxCalendarConfiguration) {
            return null;
        }
        // Initializing all the flags for the UI
        var EventsFromEmailEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.EventsFromEmailEnabled, mailboxCalendarConfiguration.EventsFromEmailEnabled);
        var CreateEventsFromEmailAsPrivate = owa_options_core_1.getFallbackValueIfNull(optionStore.CreateEventsFromEmailAsPrivate, mailboxCalendarConfiguration.CreateEventsFromEmailAsPrivate);
        return (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_txp_description),
            React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: EventsFromEmailEnabled ? ENABLE : DISABLE, options: [
                    {
                        key: DISABLE,
                        text: owa_options_strings_1.default.options_txp_disable,
                    },
                    {
                        key: ENABLE,
                        text: owa_options_strings_1.default.options_txp_enable,
                    },
                ], onChange: this.eventsToEmailUpdated }),
            React.createElement(owa_options_controls_1.OptionsCheckbox, { label: owa_options_strings_1.default.options_txp_markEventsPrivate, checked: CreateEventsFromEmailAsPrivate, disabled: !EventsFromEmailEnabled, onChange: this.updateCreateEventsFromEmailAsPrivateFlag }),
            React.createElement(TxpEventsPanel_1.default, { formFlags: optionStore.Events, mailboxCalendarConfiguration: mailboxCalendarConfiguration, flagsDisabled: !EventsFromEmailEnabled })));
    };
    TxpFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
        })
    ], TxpFull);
    return TxpFull;
}(React.Component));
exports.default = TxpFull;
//# sourceMappingURL=TxpFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/components/TxpFull.js
// module id = 5269
// module chunks = 2